<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-01 21:02:01
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-18 14:48:03
-->
<template>
  <v-card>
    <mrc_ess_skeleton_loader
      :loading="$store.state.uuid ? skeletonloading : false"
    >
      <v-card-text>
        <div class="d-flex">
          <mrc_ess_switch
            :true-value="1"
            class="mr-4"
            :readonly="disabled"
            v-if="$store.state.uuid"
            :false-value="0"
            v-model="stafflist.status"
            :true-text="$t('label_To_enable_the')"
            :false-text="$t('label_disable')"
          >
          </mrc_ess_switch>
          <!-- 在职 -->
          <mrc_ess_chip
            rounded
            color="#A3CFE4"
            class="mt-5"
            small
            v-if="stafflist.staff_status == 3"
            >{{ $t("label_Working") }}</mrc_ess_chip
          >
          <!-- 试用期 -->
          <mrc_ess_chip
            rounded
            color="#FFDCBB"
            class="mt-5"
            small
            v-if="stafflist.staff_status == 1"
            >{{ $t("label_Probation_period") }}</mrc_ess_chip
          >
          <!-- 准备转正 -->
          <mrc_ess_chip
            rounded
            color="#BFF1FC"
            class="mt-5"
            small
            v-if="stafflist.staff_status == 2"
            >{{ $t("label_Get_ready_to_turn_right") }}</mrc_ess_chip
          >
          <!-- 已经离职 -->
          <mrc_ess_chip
            rounded
            color="#E5C5A7"
            class="mt-5"
            small
            v-if="stafflist.staff_status == 6"
            >{{ $t("label_Retired") }}</mrc_ess_chip
          >
          <!-- 准备离职 -->
          <mrc_ess_chip
            rounded
            color="#DEE1B8 "
            class="mt-5"
            small
            v-if="stafflist.staff_status == 5"
            >{{ $t("label_Prepare_to_leave") }}</mrc_ess_chip
          >
          <!-- 准备入职 -->
          <mrc_ess_chip
            rounded
            color="#FFE99A"
            class="mt-5"
            small
            v-if="stafflist.staff_status == 0"
            >{{ $t("label_Preparetojoin") }}</mrc_ess_chip
          >
          <!-- 退休 -->
          <mrc_ess_chip
            rounded
            color="#D5DAE8"
            class="mt-5"
            small
            v-if="stafflist.staff_status == 7"
            >{{ $t("label_Retired_office") }}</mrc_ess_chip
          >
          <mrc_ess_chip
            rounded
            color="#dfdfdf"
            class="mt-5"
            small
            v-if="stafflist.staff_status == 4"
            >{{ $t("label_Stop") }}</mrc_ess_chip
          >
        </div>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_The_name') + '*'"
              :readonly="disabled"
              :isNational="judegNational('given_name')"
              :error-messages="
                $errors(
                  'stafflist',
                  'given_name',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="stafflist.given_name"
            >
            </mrc_ess_multiText>
            <!-- given_name -->
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Surname') + '*'"
              :readonly="disabled"
              :isNational="judegNational('family_name')"
              :error-messages="
                $errors(
                  'stafflist',
                  'family_name',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="stafflist.family_name"
            >
            </mrc_ess_multiText>
          </v-col>
          <!-- <v-col cols="4">
            <mrc_ess_multiText :label="$t('label_Nickname')"
                               :isNational="judegNational('family_name')"
                               :readonly="disabled"
                               :error-messages="$errors('stafflist', 'family_name', nocharacter)"
                               v-model="stafflist.child_name">
            </mrc_ess_multiText>
          </v-col> -->
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Show_the_name') + '*'"
              :isNational="true"
              :error-messages="
                $errors(
                  'stafflist',
                  'show_name',
                  requiredRule.concat(nocharacter)
                )
              "
              :readonly="disabled"
              v-model="stafflist.show_name"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Employee_ID') + '*'"
              :isNational="judegNational('staff_code')"
              :error-messages="
                $errors(
                  'stafflist',
                  'staff_code',
                  requiredRule.concat(nocharacter)
                )
              "
              :readonly="disabled"
              v-model="stafflist.staff_code"
            >
            </mrc_ess_multiText>
          </v-col>

          <v-col cols="12">
            <mrc_ess_brandupload
              v-model="stafflist.staff_image"
              :label="$t('label_Photo')"
              :disabled="disabled"
              @deleteicon="deleteicon"
              @changeimgSrc="changeimgSrc"
            ></mrc_ess_brandupload>
          </v-col>

          <v-col cols="12">
            <!--   :disabled="true" -->
          <!-- 2025-04-27 BJ 邮箱非必填-->
              <!-- :label="$t('label_Mailbox') + '*'" -->
            <mrc_ess_multiText
              :label="$t('label_Mailbox')"
              :isNational="judegNational('staff_email')"
              :error-messages="
                $errors('stafflist', 'staff_email',emailRule)
              "
              :readonly="disabled"
              v-model="stafflist.staff_email"
            >
            <!--   $errors('stafflist', 'staff_email', [
                  ...requiredRule,
                  ...emailRule,
                ]) -->
              <!-- :readonly="disabled" 20241211 不可修改 testlg -->
            </mrc_ess_multiText>
          </v-col>
          <!-- 部门不能修改 -->
          <v-col cols="12">
            <!-- <mrc_ess_prompt :label="$t('label_department') + '*'"
                            :errMsg="$errors('stafflist', 'dept_uuid', requiredRule)"
                            :rules="false"
                            :disabled="true"
                            v-model="stafflist.dept_uuid"
                            :backgroundColor="disabled ? '#ffffff' : 'rgb(245, 245, 245)'"
                            :obj="companyName">
            </mrc_ess_prompt> -->
            <mrc_ess_autoComplete
              :label="$t('label_department') + '*'"
              :readonly="disabled"
              :disabled="true"
              :error-messages="$errors('stafflist', 'dept_uuid', requiredRule)"
              deptView
              v-model="stafflist.dept_uuid"
              :prompt_name="companyName"
            >
            </mrc_ess_autoComplete>
          </v-col>

          <v-col cols="12" sm="6">
            <!-- <mrc_ess_prompt :label="$t('label_Position_Title') + '*'"
                            :errMsg="$errors('stafflist', 'job_post_uuid', requiredRule)"
                            :rules="false"
                            :chips="false"
                            :disabled="disabled"
                            :backgroundColor="disabled ? '#ffffff' : 'rgb(245, 245, 245)'"
                            v-model="stafflist.job_post_uuid"
                            :obj="job_post_uuid">
            </mrc_ess_prompt> -->

            <mrc_ess_autoComplete
              :label="$t('label_Position_Title') + '*'"
              :readonly="disabled"
              positionView
              :error-messages="
                $errors('stafflist', 'job_post_uuid', requiredRule)
              "
              v-model="stafflist.job_post_uuid"
              :prompt_name="job_post_uuid"
            >
            </mrc_ess_autoComplete>
          </v-col>

          <v-col cols="12" sm="6">
            <!-- <mrc_ess_prompt :label="$t('label_Post_grades') + '*'"
                            :chips="false"
                            :errMsg="
                $errors('stafflist', 'job_post_grade_uuid', requiredRule)
              "
                            :rules="false"
                            :disabled="disabled"
                            :backgroundColor="disabled ? '#ffffff' : 'rgb(245, 245, 245)'"
                            v-model="stafflist.job_post_grade_uuid"
                            :obj="mrbase_sys_job_post_grades">
            </mrc_ess_prompt> -->

            <!-- <mrc_ess_autoComplete :label="$t('label_Post_grades') + '*'"
                                  :readonly="disabled"
                                  postGradesView
                                  :error-messages="$errors('stafflist', 'job_post_grade_uuid', requiredRule)"
                                  v-model="stafflist.job_post_grade_uuid"
                                  :prompt_name="mrbase_sys_job_post_grades">
            </mrc_ess_autoComplete> -->
            <mrc_ess_autoComplete
              :label="$t('label_addStaff_m_staffGrade') + '*'"
              :readonly="disabled"
              :error-messages="
                $errors('stafflist', 'staff_grade', requiredRule)
              "
              v-model="stafflist.staff_grade"
              :prompt_name="staffGrade"
            >
            </mrc_ess_autoComplete>
          </v-col>
          <v-col cols="12">
            <mrc_ess_autoComplete
              :label="$t('label_addStaff_m_staffType') + '*'"
              :readonly="disabled"
              :error-messages="$errors('stafflist', 'staff_type', requiredRule)"
              v-model="stafflist.staff_type"
              :prompt_name="staffTypePro"
            >
            </mrc_ess_autoComplete>
          </v-col>
          <!-- <v-col cols="12"
                 sm="3">
            <v-checkbox class="mx-2"
                        :true-value="1"
                        :false-value="0"
                        :readonly="disabled"
                        v-model="stafflist.is_org_manager"
                        :label="$t('label_The_person_in_charge_of_the_unit')"></v-checkbox>
          </v-col>
          <v-col cols="12"
                 sm="3">
            <v-checkbox class="mx-2"
                        :true-value="1"
                        :false-value="0"
                        :readonly="disabled"
                        v-model="stafflist.is_dept_manage"
                        :label="$t('label_Department_head')"></v-checkbox>
          </v-col> -->

          <v-col cols="12">
            <mrc_ess_prompt
              :label="$t('label_Boss')"
              :rules="false"
              :chips="false"
              :disabled="disabled"
              v-model="stafflist.direct_leader_code"
              :obj="superior"
            >
            </mrc_ess_prompt>
          </v-col>

          <v-col cols="12">
            <!--  :backgroundColor="disabled ? '#ffffff' : 'rgb(245, 245, 245)'"  -->
            <mrc_ess_prompt
              :label="$t('label_role') + '*'"
              multiple
              :errMsg="$errors('stafflist', 'role_uuids', requiredRule)"
              :rules="false"
              :disabled="disabled"
              v-model="stafflist.role_uuids"
              :obj="spica"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12">
            <!-- :errMsg="$errors('stafflist', 'cost_center_uuid', requiredRule)" -->
            <mrc_ess_prompt
              :label="$t('label_addStaff_m_costCenter')"
              :rules="false"
              :disabled="disabled"
              v-model="stafflist.cost_center_uuid"
              :obj="{
                org_level_uuid: $store.state.currentCompany,
                prompt_name: 'cost_center',
              }"
            >
            </mrc_ess_prompt>
          </v-col>
          <v-col cols="12">
            <mrc_ess_prompt
              :label="$t('label_commonHoliday')"
              :rules="false"
              :disabled="disabled"
              v-model="stafflist.holiday_group"
              :obj="{
                prompt_name: 'ess_holiday_group_select',
              }"
            >
            </mrc_ess_prompt>
          </v-col>
        </v-row>
      </v-card-text>
      <mrc_ess_submitBtn
        @cancel="cancel"
        @success="success"
        :loading="btnIsLoading"
        v-if="!disabled"
      ></mrc_ess_submitBtn>
    </mrc_ess_skeleton_loader>
  </v-card>
</template>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
import {
  getStaffMsgDetail,
  getStaffMsgUpdate,
} from "@/service/api/staffmsg.js";
import { getDataByName } from "@/service/api/data_dictionary.js";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skeletonloading: true,
      btnIsLoading: false,
      stafflist: {
        holiday_group: "",
        job_post_uuid: "", //所属岗位
        org_level_uuid: "", //所属公司
        show_name: "", //显示名字
        job_post_grade_uuid: "", //岗位等级
        child_name: "", //小名
        christian_name: "", //员工洋名
        role_uuids: "", //所属角色
        dept_uuid: "", //所属部门
        family_name: "", //员工姓
        given_name: "", //名
        preferred_name: "",
        staff_email: "", //邮箱
        is_dept_manage: 0, //	是否部门负责人 1是 0否
        is_org_manager: 0, //	是否单位负责人 1是 0否
        is_dept_manage: 0,
        direct_leader_code: "", //	直属领导
        staff_avatar: "", //头像
        staff_code: "", //员工id
        status: 1, //默认传1
      },
      file: [],
      deleteFileList: [],
    };
  },
  validations: {
    stafflist: {
      given_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      family_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      child_name: {
        // nocharacter (value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // },
      },
      staff_code: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      show_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      staff_email: {
        // required,
        email,
      },
      dept_uuid: {
        required,
      },
      job_post_uuid: {
        required,
      },
      staff_type: {
        required,
      },
      staff_grade: {
        required,
      },
      // job_post_grade_uuid: {
      //   required,
      // },
      is_org_manager: {},
      is_dept_manage: {},
      direct_leader_code: {},
      role_uuids: {
        required,
      },
      cost_center_uuid: {
        // required,
      },
    },
  },
  created() {},
  async mounted() {
    this.national("mrbase_sys_staffs");
    if (this.$store.state.uuid) {
      await this.getstaffdetail();
    }
  },
  methods: {
    deleteicon(v) {
      if (v.uuid) this.deleteFileList.push(v);
    },
    changeimgSrc(v) {
      this.file = v;
    },
    async getstaffdetail() {
      //获取数据
      this.skeletonloading = true;
      const uuid = this.$store.state.uuid;
      const res = await getStaffMsgDetail({ uuid });
      if (res.code == 200) {
        this.stafflist = res.data;
        this.$emit('detail',res.data)
        // console.log(this.stafflist);
        this.stafflist.role_uuids =
          this.stafflist.role_uuids.indexOf(",") != -1
            ? this.stafflist.role_uuids.split(",")
            : [this.stafflist.role_uuids];
        // this.stafflist.job_post_grade_uuid = this.stafflist.job_post_grade_uuid.indexOf(',') != -1 ? this.stafflist.job_post_grade_uuid.split(',') : [this.stafflist.job_post_grade_uuid]
      }
      this.skeletonloading = false;
    },
    async cancel() {
      await this.getstaffdetail();
      this.$emit("changeReadonly");
      // this.$myConfirm({
      //   content: this.$t('message_Confirm_the_cancellation_of_the_edit'),
      // })
      //   .then((res) => {
      //     this.$router.push({
      //       name: 'staffmanagement',
      //     })
      //   })
      //   .catch((err) => { })
    },
    async success(refresh=true) {
      this.$v.stafflist.$touch();
      if (this.$v.stafflist.$error) return;
      this.btnIsLoading = true;
      this.stafflist.org_level_uuid = this.company_uuid;
      // this.stafflist.preferred_name = this.stafflist.show_name
      if (Array.isArray(this.stafflist.role_uuids))
        this.stafflist.role_uuids = this.stafflist.role_uuids.join();
      delete this.stafflist.created_by;
      delete this.stafflist.created_utc_datetime;
      delete this.stafflist.updated_by;
      delete this.stafflist.updated_utc_datetime;
      if (!this.stafflist.is_dept_manage) {
        this.stafflist.is_dept_manage = 0;
      }
      if (!this.stafflist.is_org_manager) {
        this.stafflist.is_org_manager = 0;
      }
      if (!this.stafflist.is_dept_manage) {
        this.stafflist.is_dept_manage = 0;
      }
      // 删除文件
      let deleteFileUuid = [];
      this.deleteFileList.forEach((item) => {
        deleteFileUuid.push(item.uuid);
      });
      deleteFileUuid = deleteFileUuid.join();
      // 上传文件
      await this.$uploadFiles(this.file, {
        // module_uuid: this.$store.state.menuFunctionUuid,
          module_uuid:'staff',
          function_uuid: this.$store.state.menuFunctionUuid,
        attachment_data_table: "mrbase_sys_staffs",
        attachment_data_field: "staff_image",
        org_level_uuid: this.$store.state.currentCompany,
        uuid: this.$store.state.currentCompanyClientUuid,
        // staff_uuid: this.$store.state.uuid
      })
        .then(async (res) => {
          let urllist = "";
          if (typeof res == "object" && res != undefined && res.code == 200) {
            this.stafflist.staff_image = res.uuid;
            urllist = res.uuid;
          }
          await getStaffMsgUpdate({
            ...this.stafflist,
            del: deleteFileUuid,
          }).then(async (resp) => {
            if (resp.code == 200) {
              this.deleteFileList.forEach((item) => {
                this.$deleteFile(item.uuid);
              });
              this.file = [];
              this.deleteFileList = [];
             if(refresh){
              this.$Message({
                text: this.$t("message_The_submission_was_successful"),
              });
              await this.getstaffdetail();
              this.$emit("changeReadonly");
             }else this.$emit('groupChange')
            } else {
              this.$deleteFile(urllist);
              await this.getstaffdetail();
            }
          });
        })
        .catch((err) => {
          this.$Message({ text: this.$t(err) });
          this.btnIsLoading = false;
        });
      this.btnIsLoading = false;
      // if (Array.isArray(this.stafflist.job_post_grade_uuid)) this.stafflist.job_post_grade_uuid = this.stafflist.job_post_grade_uuid.join()
    },
  },
  computed: {
    companyName() {
      //部门参照查询字段
      return {
        prompt_name: "levelUuid_deptUuid",
        org_level_uuid: this.company_uuid,
      };
    },
    company_uuid() {
      //当前选中公司
      return this.$store.state.currentCompany;
    },
    staffTypePro() {
      //员工类型参照
      return {
        prompt_name: "staff_type",
        org_level_uuid: this.company_uuid,
      };
    },
    staffGrade() {
      //员工等级参照
      return {
        prompt_name: "staff_grade",
        org_level_uuid: this.company_uuid,
      };
    },
    job_post_uuid() {
      //岗位查询
      // return { prompt_name: 'level-dept-post', dept_uuid: 'd83de2d3-36bb-47f7-9f43-3f18dd295bbb' }
      return {
        prompt_name: "level-dept-post",
        dept_uuid: this.stafflist.dept_uuid,
      };
      // return { prompt_name: 'level-dept-post', org_level_uuid: this.company_uuid, dept_uuid: this.stafflist.dept_uuid }
    },
    superior() {
      //上司高级参照
      // return { prompt_name: 'boss', org_level_uuid: this.company_uuid, staff_uuid: this.$store.state.uuid }
      return {
        prompt_name: "superior",
        org_level_uuid: this.company_uuid,
        staff_uuid: this.$store.state.uuid,
      };
    },
    spica() {
      //角色高级参照
      // return { prompt_name: 'level-role', org_level_uuid: 'd83de2d3-36bb-47f7-9f43-3f18dd295bbb' }
      return { prompt_name: "level-role", org_level_uuid: this.company_uuid };
      // return { prompt_name: 'level-role', company_uuid: this.company_uuid }
    },
    mrbase_sys_job_post_grades() {
      return {
        prompt_name: "mrbase_sys_job_post_grades",
        job_post_uuid: this.stafflist.job_post_uuid,
      };
    },
  },
  watch: {},
};
</script>

<style scoped></style>
